import ButtonBase from '@mui/material/ButtonBase';

export interface SidebarLogoProps {
  logoHeader: string;
  logoHeaderReduzido: string;
  collapsed: boolean;
  onLogoClick: () => void;
}

/**
 * Logo é só apresentação: a resolução (cor/skin/estado colapsado) já chega
 * pronta via props. Omite a `<img>` em vez de renderizar `src=""`, que o
 * browser trataria como uma requisição inválida.
 */
export function SidebarLogo({
  logoHeader,
  logoHeaderReduzido,
  collapsed,
  onLogoClick,
}: SidebarLogoProps): JSX.Element {
  const src = collapsed ? logoHeaderReduzido : logoHeader;
  const imgStyle = collapsed ? { width: 30, height: 30 } : { maxWidth: '100%', maxHeight: 57 };

  return (
    <ButtonBase
      onClick={onLogoClick}
      aria-label="Logo"
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', py: 2 }}
    >
      {src && <img src={src} alt="" style={imgStyle} />}
    </ButtonBase>
  );
}
